import React from 'react';
import { 
  FaStethoscope, 
  FaGraduationCap, 
  FaHospital, 
  FaAward, 
  FaCheckCircle,
  FaHandHoldingHeart,
  FaUserMd,
  FaCalendarAlt,
  FaUsers
} from 'react-icons/fa';

const AboutDoctor = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            About Dr. Shailendra Mohan Shukla
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-blue-700 mx-auto rounded-full"></div>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Renowned Urologist & Andrologist in Ranchi with 10+ Years of Experience
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl transform hover:scale-[1.02] transition-transform duration-300">
              <img 
                src="image.png" 
                alt="Dr. Shailendra Mohan Shukla - Urologist Ranchi"
                className="w-full h-auto object-cover rounded-2xl"
              />
              <div className="absolute top-4 right-4 bg-gradient-to-r from-blue-600 to-blue-800 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
                <FaUserMd className="inline mr-2" />
                Lead Urologist
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-8">
              <div className="bg-white p-4 rounded-xl shadow-md text-center border-l-4 border-blue-500">
                <div className="text-2xl font-bold text-blue-700">10+</div>
                <div className="text-xs text-gray-600">Years Experience</div>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-md text-center border-l-4 border-green-500">
                <div className="text-2xl font-bold text-green-700">5000+</div>
                <div className="text-xs text-gray-600">Surgeries</div>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-md text-center border-l-4 border-purple-500">
                <div className="text-2xl font-bold text-purple-700">100%</div>
                <div className="text-xs text-gray-600">Patient Satisfaction</div>
              </div>
            </div>

            <div className="mt-8 bg-gradient-to-r from-blue-50 to-white p-4 rounded-xl border border-blue-100">
              <div className="flex items-center">
                <FaAward className="text-amber-500 text-2xl mr-3" />
                <div>
                  <h4 className="font-bold text-gray-800">Medanta Hospital</h4>
                  <p className="text-sm text-gray-600">Kidney Transplant Surgeon</p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                डॉ शैलेन्द्र मोहन शुक्ला
                <span className="block text-lg text-gray-600 mt-1">(यूरोलॉजिस्ट)</span>
              </h1>
              
              <div className="flex items-start mb-4">
                <FaGraduationCap className="text-blue-600 mt-1 mr-3 flex-shrink-0" />
                <div>
                  <p className="text-gray-800 font-semibold">
                    MBBS, MS, MCh (यूरोलॉजी)
                  </p>
                  <p className="text-gray-600 text-sm">
                    Govt. Medical College, त्रिवेंद्रम (केरल)
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-5 rounded-xl border border-blue-200">
              <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center">
                <FaStethoscope className="mr-2 text-blue-600" />
                Specializations & Expertise
              </h3>
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold">यूरोलॉजिस्ट, एंड्रोलॉजिस्ट, किडनी ट्रांसप्लांट सर्जन</span> 
                <span className="text-blue-600 font-bold"> (मेदांता अस्पताल, रांची)</span> 
                <br />
                किडनी, पथरी, प्रोस्टेट एवं मूत्र रोग विशेषज्ञ
              </p>
            </div>

            <div className="space-y-4">
              <p className="text-gray-700 leading-relaxed">
                Dr. Shailendra Mohan Shukla is one of the most trusted and renowned Urologists in Ranchi, dedicated to delivering advanced and compassionate urological care. With years of experience and expertise in diagnosing and treating a wide range of urological conditions.
              </p>
              
              <div className="bg-gradient-to-r from-white to-gray-50 p-5 rounded-xl border-l-4 border-blue-500">
                <p className="text-gray-700 leading-relaxed italic">
                  "At our clinic, we specialize in the treatment of kidney stones, prostate disorders, urinary tract infections, male infertility, and other urological issues. Dr. Shukla combines the latest technology with a patient-centric approach to ensure accurate diagnosis, minimally invasive procedures, and speedy recovery."
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <FaCheckCircle className="text-blue-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Advanced Technology</h4>
                  <p className="text-sm text-gray-600">Latest surgical equipment</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <FaHandHoldingHeart className="text-green-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Patient-Centric Care</h4>
                  <p className="text-sm text-gray-600">Compassionate approach</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                  <FaHospital className="text-purple-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Minimally Invasive</h4>
                  <p className="text-sm text-gray-600">Faster recovery time</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                  <FaUsers className="text-amber-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">10+ Years Experience</h4>
                  <p className="text-sm text-gray-600">Trusted by thousands</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-6">
              <a 
                href="#appointment" 
                className="bg-gradient-to-r from-blue-600 to-blue-800 text-white px-6 py-3 rounded-lg font-semibold text-center hover:from-blue-700 hover:to-blue-900 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Book Appointment
              </a>
              <a 
                href="#contact" 
                className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold text-center border-2 border-blue-600 hover:bg-blue-50 transition-all duration-300 shadow hover:shadow-lg"
              >
                Contact Clinic
              </a>
            </div>

            <div className="pt-4">
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutDoctor;